import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Modal, Pagination, Spin } from 'hljd'
import style from './style.module.less'
import { getMoney } from '@hlj/hlj-utils'
import { dGet } from '@core/utils'
import { isSiDaTeam } from '@util'
import { Flex } from 'hljd'
import cls from 'classnames'

@observer
export default class extends Component {
  render() {
    const {
      store: {
        chooseModalVisible,
        closeChooseModal,
        list,
        selectItem,
        changeItem,
        selectedItem,
        pagination,
        onMealsPageChange,
        mealsLoading,
        value // 优惠券金额
      },
      title,
      price,
      type
    } = this.props

    return chooseModalVisible ? (
      <Modal
        title={title}
        visible={chooseModalVisible}
        onOk={changeItem}
        onCancel={closeChooseModal}
        width={800}
      >
        <Spin spinning={mealsLoading}>
          <Flex className={style.con} wrap sp>
            {list.map(item => (
              <Item
                key={item.id}
                item={item}
                onClick={selectItem}
                price={price}
                type={type}
                minPrice={value}
                selected={selectedItem.find(record => record.id == item.id)}
              />
            ))}
          </Flex>
          <div className={style.pagination}>
            <Pagination
              size="small"
              {...pagination}
              onChange={onMealsPageChange}
            />
          </div>
        </Spin>
      </Modal>
    ) : null
  }
}

class Item extends Component {
  onClick = () => {
    this.props.onClick(this.props.item)
  }

  render() {
    const { item, price, type, minPrice, selected } = this.props

    const disabled = minPrice > 0 && Number(item.actual_price) < minPrice

    return (
      <div
        className={style.conBox}
        key={item.id}
        onClick={disabled ? null : this.onClick}
        style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      >
        <dl>
          <dt>
            <img src={item.cover_path + '?imageView2/1/w/156/h/99'} />
          </dt>
          <dd>
            <h3>{item.title}</h3>

            {price && (
              <p>
                <em>{getMoney(item.actual_price)}</em>
                <i>{getMoney(item.market_price)}</i>
              </p>
            )}

            {((type === 'case' && isSiDaTeam()) ||
              (type === 'meal' && isSiDaTeam())) && (
              <div className={cls(style.member, 'text-cut')}>
                成员：{dGet(item, 'merchant.name')}
              </div>
            )}
          </dd>
        </dl>

        <img
          className={style.isCheck}
          src={
            selected
              ? '//qnm.hunliji.com/o_1b2ssv00d1uvm1pnkm9l5a717tpc.png'
              : '//qnm.hunliji.com/o_1b2ssujbl18jc3il161618oc1aju7.png'
          }
        />
      </div>
    )
  }
}
